
import * as type from '../../types/inventoryTypes'

const reducer = (state = [], action) => {
    switch (action.type) {
        case type.FETCH_INVENTORY_TYPE:
            return action.payload
        default:
            return state
    }
}

export default reducer